import * as Yup from "yup";

const CompanyWorkCondSchema = Yup.object().shape({
  shiftConditionChange: Yup.string().required("Please enter."),
  workingHours: Yup.string().test(
    "check working hour",
    "Please select this date",
    (value) => value != "00:00:00" && /[0-9]{2}\:[0-9]{2}\:[0-9]{2}/.test(value)
  ),
  // .match(/[a-zA-Z]+/, "Must not contain thai characters"),
  yearEndDate: Yup.string().test(
    "check working hour",
    "Please select this date",
    (value) => value != "00:00:00" && /[0-9]{2}\:[0-9]{2}\:[0-9]{2}/.test(value)
  ),
  lateTime: Yup.string().required("Please enter"),
  // .test(
  //   "check working hour",
  //   "Please select this date",
  //   (value) => value != "00:00:00" && /[0-9]{2}\:[0-9]{2}\:[0-9]{2}/.test(value)
  // ),
  absentTime: Yup.string().required("Please enter"),
  // .test(
  //   "check working hour",
  //   "Please select this date",
  //   (value) => value != "00:00:00" && /[0-9]{2}\:[0-9]{2}\:[0-9]{2}/.test(value)
  // ),
});

export default CompanyWorkCondSchema;
